export default __webpack_public_path__ + "static/media/13.792f79a0.jpg";